export default __webpack_public_path__ + "static/media/order.9fe88c43.svg";